import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface DocumentTypeState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allDocumentType: [] | null | any;
}
const initialState: DocumentTypeState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allDocumentType: null
};
export const documentTypeSlice = createSlice({
  name: 'documentType',
  initialState,
  reducers: {
    setAllDocumentType: (state, action) => {
      state.allDocumentType = action.payload.data;
    },
    setDocumentType: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllDocumentTypeBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllDocumentType, setDocumentType, setAllDocumentTypeBySearch,reset } = documentTypeSlice.actions;
export const allDocumentTypeDetails = (state: RootState) => state.documentType.allDocumentType;
export const getAllDocumentTypeDetails = (state: RootState) => state.documentType.data;
export const getDocumentTypeTotalRecords=(state:RootState)=>state.documentType.totalRecords;
export const getAllDocumentTypeBySearch = (state: RootState) => state.documentType.data;
export default documentTypeSlice.reducer;